import {Injectable} from '@angular/core';
import {Enterprise} from '../../model/Enterprise';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseDataService {

  private enterprises: Enterprise[] = [];

  setEnterprises(enterprises: Enterprise[]): void {
    this.enterprises = enterprises;
  }

  getEnterprises(): Enterprise[] {
    return this.enterprises;
  }

  clear(): void {
    this.enterprises = [];
  }
}
